<script setup>
import LayoutHeader from "~/layouts/LayoutHeader.vue";
import ProductContent from "~/components/product/ProductContent.vue";
import LayoutFooter from "~/layouts/LayoutFooter.vue";
import {checkDeviceClientSide, checkDeviceServerSide} from "~/utils/common";
import ModalDownload from "~/components/ModalDownload.vue";
import ModalSizeCharts from "~/components/ModalSizeCharts.vue";
import DrawerMenu from "~/components/DrawerMenu.vue";
import DrawerCart from "~/components/DrawerCart.vue";
import DrawerCartOrderPreview from "~/components/DrawerCartOrderPreview.vue";
import DrawerCartMobileNumberEdit from "~/components/DrawerCartMobileNumberEdit.vue";
import DrawerCartShipmentEdit from "~/components/DrawerCartShipmentEdit.vue";
import ModalLoadingProgress from "~/components/ModalLoadingProgress.vue";
import DrawerAI from "~/components/DrawerAI.vue";
import DrawerAIMore from "~/components/DrawerAIMore.vue";
import DrawerAIFAQ from "~/components/DrawerAIFAQ.vue";
import ModalPremiumIntroduce from "~/components/ModalPremiumIntroduce.vue";
import DrawerReviewsRecommend from "~/components/review/DrawerReviewsRecommend.vue";
import DrawerReviewsAll from "~/components/review/DrawerReviewsAll.vue";
import DrawerReviewsPhoto from "~/components/review/DrawerReviewsPhoto.vue";
import DrawerProductShare from "~/components/product/DrawerProductShare.vue";
import DrawerProductVoteCreator from "~/components/product/DrawerProductVoteCreator.vue";
import DrawerProductVotePlayer from "~/components/product/DrawerProductVotePlayer.vue";

definePageMeta({
  keepalive: true
})

checkDeviceServerSide()

onMounted(async () => {
  checkDeviceClientSide()
})
</script>

<template>
  <layout-header/>
  <product-content/>
  <layout-footer/>

  <modal-download/>
  <modal-size-charts/>
  <modal-premium-introduce/>
  <drawer-a-i/>
  <drawer-a-i-more/>
  <drawer-a-i-f-a-q/>
  <drawer-menu/>
  <drawer-cart/>
  <drawer-cart-order-preview/>
  <drawer-cart-mobile-number-edit/>
  <drawer-cart-shipment-edit/>
  <modal-loading-progress/>

  <drawer-product-share/>
  <drawer-product-vote-creator/>
  <drawer-product-vote-player/>

  <drawer-reviews-recommend/>
  <drawer-reviews-all/>
  <drawer-reviews-photo/>
</template>

<style scoped lang="scss">

</style>
